import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ProjetoCadastro } from '../../../models/projeto-cadastro.model';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ProjetoCustoService } from '../../../services/projeto-custo.service';
import { MaskService } from 'src/app/shared/services/mask.service';
import { AtualizacoesAudit } from '../../../models/atualizacoes-audit.model';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { formatDate } from 'ngx-bootstrap/chronos';
import { environment } from 'src/environments/environment';
import { ProjetoCadastroService } from '../../../services/projeto-cadastro.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-custo-edit',
  templateUrl: './custo-edit.component.html',
  styleUrls: ['./custo-edit.component.scss'],
})
export class CustoEditComponent
  extends BaseFormComponent<ProjetoCadastro>
  implements OnInit, OnDestroy
{
  actionLabel: string = 'Novo';
  tiposList: Array<{ id: number; label: string }> = [];
  idProjeto: any;
  projeto: ProjetoCadastro;
  fonteList: Array<{ id: number; label: string }> = [];
  aumentoDespesaList: Array<{ id: number; label: string }> = [];
  reducaoDespesaList: Array<{ id: number; label: string }> = [];
  permissoes: any;
  audit: AtualizacoesAudit;
  filters: any;
  lastTabGroupName: string = '';
  modalCloneRef?: BsModalRef;
  clone_title: string;

  @ViewChild('modalClone') modalClone: TemplateRef<any>;

  constructor(
    private myService: ProjetoCustoService,
    private projetoService: ProjetoCadastroService,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService,
    public maskService: MaskService,
    private modalService: BsModalService,
    private router: Router
  ) {
    super(activatedRoute);
  }

  ngOnInit(): void {
    this.loading();
    this.filters = this.activatedRoute.snapshot.data['filters'];
    this.initForm();

    let currentUrl = this.router.url;
    const regex = /projeto\/(\d+)\/custos/;
    const match = currentUrl.match(regex);

    if (match) {
      this.idProjeto = match[1];
      this.initLoadData();
      this.audit = {
        pp_id: this.idProjeto,
      };
    } else {
      console.log('ID não encontrado');
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadData() {
    this.addSub(
      this.myService.getById(this.idProjeto).subscribe((res) => {
        this.projeto = res['projeto'];
        this.fonteList = res['fonteList'];
        this.reducaoDespesaList = res['reducaoDespesaList'];
        this.aumentoDespesaList = res['aumentoDespesaList'];
        this.permissoes = res['permissoes'];

        if (this.projeto) {
          this.actionLabel = 'Editar';
          this.form.patchValue(this.projeto);

          if (this.projeto?.questions?.length) {
            const formGroup = {};
            this.projeto.questions.forEach((field) => {
              formGroup[field.question_id] = new FormGroup({
                question_id: new FormControl(field.question_id),
                ds_value: new FormControl(
                  field.ds_value,
                  !field.allow_null ? [Validators.required] : []
                ),
              });
            });

            this.getFormArray('questions').push(new FormGroup(formGroup));
          }
        }
        if (!this.permissoes?.canEditSelect) {
          this.form.get('resource_id').disable();
          this.form.get('decreased_spending').disable();
          this.form.get('increased_spending').disable();
        }
        if (!this.permissoes?.canEditForm) {
          this.form.get('cost_total').disable();
          this.form.get('perc_loan').disable();
        }
        this.form.get('cost_loan').disable();
        this.form.get('cost_without_loan').disable();

        this.loaded();
      })
    );
  }

  getFormArray(form: string): FormArray {
    return this.form.get(form) as FormArray;
  }

  getControl(form: string) {
    const formGroup = this.getFormArray('questions').at(0)?.['controls']?.[
      form
    ] as FormGroup;
    return formGroup?.get('ds_value');
  }

  initForm() {
    this.form = new FormGroup({
      cost_total: new FormControl('', Validators.maxLength(16)),
      perc_loan: new FormControl('', Validators.maxLength(13)),
      cost_loan: new FormControl(''),
      cost_without_loan: new FormControl(''),
      resource_id: new FormControl(''),
      decreased_spending: new FormControl(''),
      increased_spending: new FormControl(''),
      questions: new FormArray([]),
    });
  }

  maskCurrency(event, field) {
    let value = this.maskService.formatarMedidaFisica(
      event.target?.value,
      2,
      12
    );
    this.form.get(field).setValue(value);
  }

  shouldShowHeader(currentTabGroupName: string, index: number): boolean {
    if (index === 0 || currentTabGroupName !== this.lastTabGroupName) {
      this.lastTabGroupName = currentTabGroupName;
      return true;
    }
    return false;
  }

  fieldMessageRequireds(form: string): boolean {
    return this.getControl(form)?.invalid && this.getControl(form)?.dirty;
  }

  fieldErrosFormArray(form: string) {
    return this.getControl(form)?.errors;
  }

  formatarMedidaFisica2(form, decimal = 2) {
    let value = this.maskService.formatarMedidaFisica(
      this.getControl(form)?.value,
      decimal
    );
    this.getControl(form)?.setValue(value);
  }

  clearInput(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    input.value = '';
  }

  voltar() {
    this.navigation.back(['pre-projeto/projeto/' + this.idProjeto]);
  }

  getDataCreate(): ProjetoCadastro {
    let data: ProjetoCadastro;
    data = Object.assign({}, data, this.form.value);

    if (this.projeto?.questions) {
      this.projeto.questions.forEach((field) => {
        if (field.type_id == this.filters?.ppQuestion['TYPE_DATA']) {
          const formatoDataRegex = /^\d{2}\/\d{2}\/\d{4}$/;
          const dataSimples = this.getControl(field.question_id)?.value;
          if (dataSimples && !formatoDataRegex.test(dataSimples)) {
            data.questions[0][field.question_id].ds_value = formatDate(
              dataSimples,
              'DD/MM/YYYY'
            );
          }
        }
      });
      data.questions = data.questions[0];
    }
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.projeto?.id) {
        this.addSub(
          this.myService
            .update(this.getDataCreate(), this.projeto?.id)
            .subscribe({
              next: (res: ProjetoCadastro) => {
                this.msgSuccess('Cadastro alterado com sucesso!');
                EventSharedService.get('auditRefresh').emit();
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error.message);
                this.loaded();
              },
            })
        );
      }
    } else {
      this.markAsDirty();
    }
  }

  confirmExcluir() {
    this.alertConfirmation(null, 'Tem certeza que deseja excluir o projeto?').subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {
    this.loading();
    this.projetoService.delete(this.idProjeto).subscribe({
      next: () => {
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.navigation.replace(['/pre-projeto', 'projeto']);
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error);
      },
    });
  }

  closeCloneModal() {
    this.modalCloneRef?.hide();
  }

  openCloneModal() {
    this.clone_title = '';
    this.modalCloneRef = this.modalService.show(this.modalClone);
  }

  clonar() {
    this.closeCloneModal();
    this.loading();
    if (this.idProjeto && this.permissoes.canClone) {
      const obj = {
        clone_id: this.idProjeto,
        clone_title: this.clone_title,
      };
      this.addSub(
        this.projetoService.clonar(obj).subscribe({
          next: () => {
            this.msgSuccess('Clonado com sucesso!');
            this.loaded();
          },
          error: (error) => {
            this.msgError(error?.error?.message);
            this.loaded();
          },
        })
      );
    }
  }

  imprimir() {
    this.loading();
    const url = `${environment.serverUrl}/rest/pre-projeto/relatorio/${this.idProjeto}`;
    this.loaded();
    window.open(url, '_blank');
  }
}
